<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication.html" xml:lang="en-US">
<div class="story">
<p class="pl-center">To the fabulous Sharon Kendrick, who sorted out what was wrong with an early draft of this book on a long, rainy, Irish drive to and from Sligo town (and an atmospheric tour of Yeats country)—both of which amounted to a master class in writing for the Harlequin Presents line.</p>
<p class="pl-center">And to Abby Green, Heidi Rice, Fiona Harper and Chantelle Shaw, for our inspiring days in Delphi. </p>
<p class="pl-center">And to all the readers who wrote me to ask for Nikolai’s story. This is for you most of all!</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?2e41d824